import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import { Mode } from "../components/shared/darkModeToggle";
import {
  ColorPalette,
  getSkinConfigByUnivers,
  SkinConfig,
} from "../styles/skin";
import { STORAGE_KEYS } from "../utils/defines";

export interface ComponentsState {
  popupsCount: number;
  skinConfig: SkinConfig;
  mode?: Mode;
  isDatalayerReady: boolean;
  //lang?: string;
}

const initialState: ComponentsState = {
  popupsCount: 0,
  skinConfig: getSkinConfigByUnivers(""),
  mode: localStorage.getItem(STORAGE_KEYS.Mode) as Mode,
  isDatalayerReady: false,
};

export const componentsSlice = createSlice({
  name: "components",
  initialState,
  reducers: {
    setDatalayerReady(state, payload: PayloadAction<boolean>) {
      state.isDatalayerReady = payload.payload;
    },
    setColorTheme(state, payload: PayloadAction<ColorPalette>) {
      state.skinConfig.colorPalette = payload.payload;
    },
    setSkinConfig(state, payload: PayloadAction<SkinConfig>) {
      state.skinConfig = payload.payload;
    },
    setMode(state, payload: PayloadAction<Mode>) {
      state.mode = payload.payload;
      localStorage.setItem(STORAGE_KEYS.Mode, state.mode);
    },
  },
});

export const { setColorTheme, setSkinConfig, setMode, setDatalayerReady } =
  componentsSlice.actions;
export const componentsReducer = componentsSlice.reducer;
